// Permission APIs
import type { Permission } from '@/models';

export async function list(): Promise<Permission[]> {
  return [];
}
